import React from 'react';

import { Nullable } from '@clearverify/types';

import { useGetVerifierInfoByVerificationRequestQuery } from 'src/api';

export const useVerifierByVerificationRequestId = (verificationRequestId: Nullable<string>) => {
  const { data, loading } = useGetVerifierInfoByVerificationRequestQuery({
    variables: { verificationRequestId: verificationRequestId || '' },
    skip: !verificationRequestId,
  });

  const verifier = React.useMemo(() => {
    return data?.getVerifierInfoByVerificationRequest;
  }, [data?.getVerifierInfoByVerificationRequest]);

  return { verifier, loading };
};
